import styled from 'styled-components'

import { Stack } from '@procsea/design-system'

export const MembershipList = styled(Stack)`
  width: 250px;
  height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 -${props => props.theme.spacings.medium};
  padding: 0 0 0 ${props => props.theme.spacings.small};
`

export const ListSubtitle = styled.div`
  text-transform: uppercase;
  background-color: ${props => props.theme.colors.primary.lighter};
  padding: ${props => props.theme.spacings.xsmall} ${props => props.theme.spacings.xsmall}
    ${props => props.theme.spacings.xsmall} ${props => props.theme.spacings.large};
  color: ${props => props.theme.colors.secondary.base};
  margin: 0 -${props => props.theme.spacings.medium};
  position: sticky;
  top: 0;
  z-index: 10;
`
